import React, { useEffect, useState } from "react";
import HorizontalSplitIcon from "@mui/icons-material/HorizontalSplit";
import NotificationsIcon from "@mui/icons-material/Notifications";
import Form from "react-bootstrap/Form";
import Avatar from "../css/Avatar1.png";
import Bell from  "../css/bellIcon.png"
import ViewHeadlineIcon from "@mui/icons-material/ViewHeadline";
import MenuIcon from "@mui/icons-material/Menu";
import { matchPath, useLocation } from "react-router-dom";
import ModalBox from "../components/modal/ModalBox";
import { Input } from "../components/Form";
import { getNotificationApi, markRead } from "../services/notificationManagement";
import { toastMessage } from "../utils/toastMessage";
import useResponsive from "../hooks/useResponsive";

const ROUTE_ARR = {
  "/consultant-payout": ["payoutList"],
  "/music-category": ["musicCategory", "musicList"],
  "/user": ["userList", "useDetailList", "deletedUserList"],
  "/consultant-management": ["consultantList", "deletedConsultantList"],
  "/category": ["category", "categoryMedia"],
  "/banner": [],
  "/dashboard": [],
  "/dashboard-marketing": [],
  "/meditation-category": ["meditationCategory"],
  "/training-management": ["trainingCategory", "trainingList"],
  "/image-management": ["imageList"],
  "/explore-management": ["exploreList"],
  "/request-management": ["requestList"],
  "/discount-management": ["discountList"],
  "/notification-management": ["notificationList"],
  "/horoscope-management": ["horoscopeList"],
  "/live-management": ["liveList"],
  "/support-management": ["queryList", "supportListType"],
  "/form-16A": ["formList"],
  "/concern-management": ["concern", "remedyList"],
  "/transaction-management": ["transaction"],
    "/daily-consult-performance" : ["Consult Performance"],
    "/completed-queries" : ["Completed Queries"],
};
export default function Header({ onMenuToggle, isSidebarOpen }) {
  // const name = localStorage.getItem('auction_userName')
const [modal, setModal] = useState(false)
const [message, setMessage] = useState([])
const [readId , setReadId] = useState('')
const [notificationCount , setNotificationCount] = useState(0)
  const location = useLocation();
const fetchNotification = async () => {
 try {
  const res = await getNotificationApi({
    page: 1,
    limit: 10,
  });
  if(res?.status === 200){
    setMessage(res?.data?.result?.list)
    if(!res?.data?.result?.list?.readByAdmin){
      console.log("i am here")
    setNotificationCount(notificationCount => notificationCount+1)
    toastMessage("You received new notification", )
    }
  }
 } catch (error) {
  console.log(error,"Error in Fetching Notification");
 }
}
const readNotification = async () => {
  try {
    console.log("Read Id===>",readId)
  const res = await markRead({ notificationId: readId });
    if(res?.status === 200){
      console.log("Read Notification Successfully")
    }
  } catch (error) {
    console.log(error, "Error in Fetching Notification");
  }
};

  useEffect(() => {
    Object.entries(ROUTE_ARR).forEach(([key, val]) => {
      const match = matchPath(
        {
          path: `${key}/*`,
          exact: false,
          strict: false,
        },
        location.pathname
      );

      // if match then remove all previous keys
      // console.log(match)
      if (match) {
        try {
          let tempVar = {};
          let localData = JSON.parse(localStorage.getItem("admin"));
          val.forEach((item) => {
            tempVar = { ...tempVar, [item]: localData[item] };
          });
          localStorage.setItem("admin", JSON.stringify(tempVar));
        } catch (err) {
          // localStorage.removeItem("admin") 
        }
      }
    });
  }, [location]);
  // useEffect(() => {
  //   fetchNotification()
  // }, ['/dashboard'])
  console.log("Notification Count===>",notificationCount)
  
  const { isMobile } = useResponsive();

  return (
    <>
      {/* Desktop Header */}
      {!isMobile && ( 
        <div className="mainHead">
          <div className="header">
            <ViewHeadlineIcon
              style={{
                color: "white",
                fontSize: 35,
                cursor: "pointer",
              }}
            />

            <div className="mx-10" style={{ position: 'relative' }}>
              {notificationCount !== 0 && (
                <div
                  style={{
                    paddingVertical: 10,
                    borderRadius: 20,
                    backgroundColor: '#f00',
                    alignItems: 'center',
                    position: 'absolute',
                    paddingHorizontal: notificationCount > 9 ? 10 : 10,
                    top: -4,
                    left: -10,
                  }}
                >
                  <p
                    style={{
                      padding: '5px 10px',
                      fontSize: 10,
                      color: 'white',
                    }}
                  >
                    {notificationCount > 9 ? '9+' : notificationCount}
                  </p>
                </div>
              )}
              <img 
                onClick={() => {
                  setModal(true)
                }}
                className="mx-2 fs-6"
                style={{ height: "30px", width: "30px" }}
                src={Bell}
              />
              
              <img
                style={{ height: "40px", width: "40px" }}
                src={Avatar}
                alt="profile"
              />
              <span className="mx-2 fs-6">Admin</span>
            </div>
          </div>
        </div>
      )}

      {/* Mobile Header */}
      {isMobile && (
        <div className="mobile-header">
          <div className="mobile-header-content">
            <div className="mobile-header-left">
              <MenuIcon
                onClick={onMenuToggle}
                style={{
                  color: "#ff8989",
                  fontSize: 28,
                  cursor: "pointer",
                }}
              />
              <h2 className="mobile-logo">Vedic Meet</h2>
            </div>
            <div className="mobile-header-right">
              {notificationCount !== 0 && (
                <div className="mobile-notification-badge">
                  <span>{notificationCount > 9 ? '9+' : notificationCount}</span>
                </div>
              )}
              <img 
                onClick={() => {
                  setModal(true)
                }}
                className="mobile-bell-icon"
                style={{ height: "24px", width: "24px", marginRight: "10px" }}
                src={Bell}
                alt="notifications"
              />
              <img
                style={{ height: "32px", width: "32px", borderRadius: "50%" }}
                src={Avatar}
                alt="profile"
              />
            </div>
          </div>
        </div>
      )}
    <ModalBox
  status={modal}
  onClose={() => {
    setModal(false);
  }}
  title={"Notification"}
  closeIcon
  size={"sm"}
  custom
  customizedFooter={
    <div
      style={{
        maxHeight: "300px", // Adjust height as needed
        overflowY: "auto",
        padding: "10px",
      }}
    >
      {message &&message?.map((item, index) => {
        return (
          <div
            key={index}
            style={{
              padding: "14px 24px",
            }}
          >
            <p
              style={{
                fontSize: "14px",
                color: "#4A4A4A",
                margin: 0,
                padding: "10px",
                backgroundColor: item?.readByAdmin ? "#ffffff" : "#EDEDEE",
              }}
              onClick={() => {
                setReadId(item._id);
                readNotification();
              }}
            >
              {item?.message}
            </p>
            <p
              style={{
                fontSize: "12px",
                color: "#4A4A4A",
                marginTop: "12px",
                margin: 0,
              }}
            >
              {/* {moment(item?.createdAt).calendar()} */}
            </p>
          </div>
        );
      })}
      <div
        style={{
          borderBottom: "0.8px solid #4A4A4A80",
        }}
      />
    </div>
  }
></ModalBox>
  
      </>
  );
}
